import { render, staticRenderFns } from "./userIndex.vue?vue&type=template&id=32aaf356"
import script from "./userIndex.vue?vue&type=script&lang=js"
export * from "./userIndex.vue?vue&type=script&lang=js"
import style0 from "./userIndex.vue?vue&type=style&index=0&id=32aaf356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports